export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('nomoney-app');

    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch (errors) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('nomoney-app', serializedState);
  } catch (errors) {
    // Ignore write errors
  }
};
